import { render, staticRenderFns } from "./imcNinas2a5A.vue?vue&type=template&id=18811574&scoped=true&"
import script from "./imcNinas2a5A.vue?vue&type=script&lang=js&"
export * from "./imcNinas2a5A.vue?vue&type=script&lang=js&"
import style0 from "./imcNinas2a5A.vue?vue&type=style&index=0&id=18811574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18811574",
  null
  
)

export default component.exports